import React from 'react';
import './WorkInProgress.css'; 
import Parser from 'html-react-parser';

const WorkInProgress = ({ message = 'This section is under development.', showIcon = true }) => {
    return (
        <div className="work-in-progress-container">
            {showIcon && <i className="fa fa-tools work-in-progress-icon"></i>}
            <p className="work-in-progress-message">{Parser(message)}</p>
        </div>
    );
};

export default WorkInProgress;